import { Link as RouterLink, useLocation } from 'react-router-dom';

import { landingLink } from '@/app/navigation';
import { ROLE_LABELS } from '@/auth/roles';
import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui/Button';

import { StatusPage } from './StatusPage';

/** Shown when the role guard blocks a route. */
export function ForbiddenPage() {
  const { user } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
  const back = landingLink(user?.role);

  return (
    <StatusPage
      title="You do not have access to that page"
      documentTitle="No access"
      address={from}
      action={
        <Button component={RouterLink} to={back.to} variant="secondary">
          {back.label}
        </Button>
      }
    >
      {from ? 'needs a different role. ' : null}
      You are currently acting as{' '}
      <strong>{user ? ROLE_LABELS[user.role] : 'nobody'}</strong>.
    </StatusPage>
  );
}
